import axios from "axios";
import Cookies from "js-cookie";
const baseUrl = process.env.REACT_APP_API_URL;
//  const baseUrl = "http://localhost:6002"
export const getAllDrone = async (data) => {
  const url =
    baseUrl +
    `/getDrone?page=${data.page}&limit=2000${data.limit}&sort=${data.sort}`;
  try {
    const response = await axios.get(url);
    return response.data; 
  } catch (error) {
    console.log(error);
  }
};
export const getSingleDrone = async (id) => {
  const url = baseUrl + `/getSingleDrone?droneId=${id}`;
  // const url = `http://localhost:6002/getSingleDrone?droneId=${id}`;
  try {
    const response = await axios.get(url, {
      headers: {
        token: Cookies.get("token"),
      },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
export const getDronesParts = async (data) => {
  const params = new URLSearchParams({
    page: data.page || 1,
    limit: data.limit || 10,
    categoryId: data.categoryId?.trim() || "",
    subcategory: data.subcategory?.trim() || "",
    search: data.search?.trim() || "",
  });

  const url = `${baseUrl}/getDronePart?${params.toString()}`;

  try {
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching drone parts:", error);
    throw error;
  }
};


export const getDroneSoftware = async (data) => {
  const url =
    baseUrl +
    `/getDroneSoftware?page=${data.page}&limit=2000${data.limit}&categoryId=${data.categoryId}&search=${data.search}`;
  try {
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
export const getDronesPartDetails = async (id) => {
  const url = baseUrl + `/getSingleDronePart?dronePartId=${id}`;
  try {
    const response = await axios.get(url, {
      headers: {
        token: Cookies.get("token"),
      },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getDroneSoftwareDetails = async (id) => {
  const url = baseUrl + `/getSingleDroneSoftware?droneSoftwareId=${id}`;
  try {
    const response = await axios.get(url, {
      headers: {
        token: Cookies.get("token"),
      },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
};


export const getDronesByCategoryId = async (data) => {
  const url =
    baseUrl +
    `/getDroneByCategoryId?categoryId=${data.id}&page=${data.page}&limit=${data.limit}&sort=${data.sort}`;
  try {
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
export const droneInquire = async (data) => {
  const url = baseUrl + `/createEnquiry`;
  try {
    const response = await axios.post(url, data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
export const dronePartsInquire = async (data) => {
  const url = baseUrl + `/createEnquiryParts`;
  try {
    const response = await axios.post(url, data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
export const LoanInquire = async (data) => {
  const url = baseUrl + `/addDroneLoans`;
  try {
    const response = await axios.post(url, data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
export const addEnroll = async (data) => {
  const url = baseUrl + `/addEnroll`;
  try {
    const response = await axios.post(url, data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};